<template>
  <div>
    <v-row style="margin-left:20px;margin-right:20px;">
      <v-col md="8">
        <div class="hh">
          <h5
            class="my"
            style="text-align: center;padding:9px!important; color:white!important;font-family:'Quicksand', sans-serif;"
          >Delivery Addresses</h5>
        </div>
        <div style="background-color:white;">
          <v-row>
            <v-col md="6">
              <v-text-field
                label="First Name"
                type="text"
                class="form-control"
                id="productname"
                v-model="firstname"
                required
              />
            </v-col>
            <v-col md="6">
              <v-text-field
                label="Last Name"
                v-model="lastname"
                type="text"
                class="form-control"
                id="productname"
                :rules="nameRules"
                required
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6">
              <v-text-field
                label="Pincode"
                v-model="pincode"
                type="text"
                class="form-control"
                id="productname"
                :rules="nameRules"
                required
              />
            </v-col>
            <v-col md="6">
              <v-text-field
                label="Locality"
                v-model="locality"
                type="text"
                class="form-control"
                id="productname"
                :rules="nameRules"
                required
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6">
              <v-text-field
                label="Country"
                v-model="country"
                type="text"
                class="form-control"
                id="productname"
                :rules="nameRules"
                required
              />
            </v-col>
            <v-col md="6">
              <v-select v-model="city" :items="cities" label="city" dense :rules="stateRules"></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6">
              <v-textarea v-model="streetAddress" label="Street" hint="Hint text"></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6">
              <v-select v-model="state" :items="states" label="State" dense :rules="stateRules"></v-select>
            </v-col>

            <v-col md="6">
              <v-select
                v-model="district"
                :items="districts"
                label="District"
                dense
                :rules="districtRules"
              ></v-select>
            </v-col>
            <v-layout wrap justify-center>
              <v-flex xs12 md12 pt-2 text-center>
                <v-btn
                  rounded
                  :disabled="false"
                  width="500px"
                  class="text-capitalize hh"
                  dark
                  :ripple="false"
                  color="#26af82"
                  @click="reginit"
                >SUBMIT</v-btn>
              </v-flex>
            </v-layout>
          </v-row>
        </div>
      </v-col>
      <v-col md="3">
        <v-card class="mx-auto" max-width="600" height="100%">
          <v-card-title>Price Details</v-card-title>
          <v-row>
            <v-col md="8" v-for="i in billingaddress">{{i._id}}</v-col>
            <v-col md="6">
              <h3 style="padding-left:20px;">Price</h3>
            </v-col>
            <v-col md="6">
              <h3>{{total}}</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col md="6">
              <h3 style="padding-left:20px;">Total Tax</h3>
            </v-col>
            <v-col md="6">
              <h3>{{tottax}}</h3>
            </v-col>
          </v-row>
          <hr />
          <v-row>
            <v-col md="6">
              <h3 style="padding-left:20px;">Total Payable</h3>
            </v-col>
            <v-col md="6">
              <h3>{{subtotal}}</h3>
            </v-col>
            <v-col md="8" style="text-align:center;">
              <v-btn color="orange darken-2" dark @click="payment">Proceed to Pay</v-btn>
            </v-col>
          </v-row>

          <v-card-text></v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <div class="col-md-12 row">
      <div class="col-md-6 column" style="padding-left:21px;" v-for="listing in billingaddress">
        <div class="col-md-12 row">
          <div class="col-md-12">
            <div class="card jio jp">
              <label style="color:black!important; font-size:15px;font-weight: bold!important;">
                <input
                  type="radio"
                  v-model="billid"
                  required
                  name="profileImg"
                  :value="listing._id"
                />

                <br />
                <span style="padding-left:35px;">{{listing.pincode}}</span>
                <span style="padding-left:35px;">{{listing.firstname}}</span>
              </label>
            </div>
            <br />
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />
    <!-- <v-card style="margin-top:50px;" max-width="1000" height="100%" class="mx-auto">
              <v-card-title>Billing Address</v-card-title>
                  <v-row>
                <v-col md="6">
                      <v-text-field
                      label="First Name"
                   
                    type="text"
                    class="form-control"
                    id="productname"
                    v-model="firstname"
                  
                    required
                  
                      />
                </v-col>
                   <v-col md="6">
                      <v-text-field
                      label="Last Name"
                     v-model="lastname"
                    type="text"
                    class="form-control"
                    id="productname"
                  
                      :rules="nameRules"
                    required
                  
                      />
                </v-col>
            </v-row>
            <v-row>
                 <v-col md="6">
                       <v-text-field
                      label="Pincode"
                       v-model="pincode"
                    type="text"
                    class="form-control"
                    id="productname"
               
                      :rules="nameRules"
                    required
                  
                      />
                </v-col>
                 <v-col md="6">
                       <v-text-field
                      label="Locality"
                       v-model="locality"
                    type="text"
                    class="form-control"
                    id="productname"
               
                      :rules="nameRules"
                    required
                  
                      />
                </v-col>
            </v-row>
            <v-row>
                 <v-col md="6">
                       <v-text-field
                      label="Country"
                       v-model="country"
                    type="text"
                    class="form-control"
                    id="productname"
               
                      :rules="nameRules"
                    required
                  
                      />
                </v-col>
                 <v-col md="6">
                     <v-select   v-model="city" :items="cities" label="city" dense  :rules="stateRules"></v-select>
                </v-col>
            </v-row>
            <v-row>
                
                  <v-col md="6">
                   <v-textarea
               v-model="streetAddress"
          label="Street"
        
          hint="Hint text"
        ></v-textarea>
                </v-col>
            </v-row>
              <v-row>
                    <v-col md="6">
                   <v-select   v-model="state" :items="states" label="State" dense  :rules="stateRules"></v-select>
</v-col>
             
               <v-col md="6">
                   <v-select v-model="district" :items="districts" label="District" dense   :rules="districtRules"></v-select>
               </v-col>
                <v-layout wrap justify-center>
          <v-flex xs12 md12 pt-2 text-center>
            <v-btn
              rounded
              :disabled="false"
              width="500px"
              class="text-capitalize hh"
              dark
           
              :ripple="false"
              color="#26af82"
          @click="billSubmit"
            >SUBMIT</v-btn>
          </v-flex>
         
        </v-layout>
              </v-row>
    </v-card>-->
  </div>
</template>
<script>
import store from "../../store";
import axios from "axios";
import { request } from "http";
export default {
  data() {
    return {
      // validateselection: null,
      //   validateselection1: null,
      states: [],
      statesId: [],
      state: null,
      stateId: null,
      districts: [],
      districtsId: [],
      district: null,
      districtId: null,
      cities: [],
      citiesId: [],
      city: null,
      cityId: null,

      total: "",
      subtotal: "",
      tottax: "",
      userData: "",
      delid: "",
      billid: "",
      mobile: "",
      email: "",
      firstname: "",
      lastname: "",
      billingaddress: [],
      deliveryaddress: [],
      billId: ""
    };
  },

  beforeMount() {
    this.stateList();
  },
  watch: {
    state: function() {
      this.districtList();
    },
    district: function() {
      this.cityList();
    }
  },
  mounted: function() {
    this.getProduct();
    this.getUser();
  },
  methods: {
    payment() {
      var datas = {};

      datas["billingaddressindex"] = this.billid;
      datas["deliveryaddressindex"] = "5e58f6672d74d9315e6f72f2";
      datas["amount"] = this.subtotal;

      datas["firstname"] = this.firstname;
      datas["lastname"] = this.lastname;
      datas["mobile"] = this.mobile;
      datas["email"] = this.email;

      // this.dialog = false;
      axios({
        method: "POST",
        url: "/payment/checkout/",
        data: datas,
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          window.location = response.data.redirecturl;
        })
        .catch(e => {
          this.msg = "Not Success";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        });
    },
    getUser() {
      axios({
        method: "GET",
        url: "/user/profile/",

        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      }).then(response => {
        this.userData = response.data.data;
        this.mobile = response.data.data.phone;
        this.email = response.data.data.email;
        this.firstname = response.data.data.firstname;
        this.lastname = response.data.data.lastname;
        this.billingaddress = response.data.data.billingaddress;

        var tempid = [];
        for (var i = 0; i < this.billingaddress.length; i++) {
          var tyid = this.billingaddress[i]._id;
          temp.push(ty);
          tempid.push(tyid);
        }

        this.billid = tempid;

        this.deliveryaddress = response.data.data.deliveryaddress;

        var tempid = [];
        for (var i = 0; i < this.deliveryaddress.length; i++) {
          var tyid = this.deliveryaddress[i]._id;
          temp.push(ty);
          tempid.push(tyid);
        }

        this.delid = tempid;
        this.visible = false;
      });
    },
    getProduct() {
      axios({
        method: "GET",
        url: "/Cart/all/",

        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      }).then(Response => {
        this.prodata = Response.data.cart;
        this.total = Response.data.total;
        this.subtotal = Response.data.subtotal;
        this.tottax = Response.data.totaltax;
        // console.log(Response);
      });
    },
    stateList() {
      // this.dialog = false;

      axios({
        method: "GET",
        url: "/loc/StateList/"
      })
        .then(response => {
          this.states = response.data.data;
          var temp = [];
          var tempid = [];
          for (var i = 0; i < this.states.length; i++) {
            var ty = this.states[i].name;
            var tyid = this.states[i]._id;
            temp.push(ty);
            tempid.push(tyid);
          }
          this.states = temp;
          this.statesId = tempid;

          console.log(err);
        })
        .catch(err => {
          this.msg = "Something Went Wrong";
          // alert(err);
          // console.log(err);
        });
    },
    districtList() {
      this.visible = true;
      for (var j = 0; j < this.states.length; j++) {
        if (this.state == this.states[j]) {
          this.stateId = this.statesId[j];
        }
      }
      axios({
        method: "GET",
        url: "/loc/DistrictList/?stateid=" + this.stateId
      })
        .then(response => {
          // console.log("VehicleModel", response);
          this.districts = response.data.data;
          var temp = [];
          var tempid = [];
          for (var i = 0; i < this.districts.length; i++) {
            var ty = this.districts[i].name;
            var tyid = this.districts[i]._id;
            temp.push(ty);
            tempid.push(tyid);
          }
          this.districts = temp;
          this.districtsId = tempid;
          this.visible = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    cityList() {
      this.visible = true;
      for (var j = 0; j < this.districts.length; j++) {
        if (this.district == this.districts[j]) {
          this.districtId = this.districtsId[j];
        }
      }
      axios({
        method: "GET",
        url: "/loc/CityList/?districtid=" + this.districtId
      })
        .then(response => {
          // console.log("VehicleModel", response);
          this.cities = response.data.data;
          var temp = [];
          var tempid = [];
          for (var i = 0; i < this.cities.length; i++) {
            var ty = this.cities[i].name;
            var tyid = this.cities[i]._id;
            temp.push(ty);
            tempid.push(tyid);
          }
          this.cities = temp;
          this.citiesId = tempid;
          this.visible = false;
        })
        .catch(err => {
          console.log(err);
        });
    },
    billSubmit() {
      if (this.state == null) {
        this.msg = "Please select state options";
        this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        this.validateselection = false;
      }

      for (var j = 0; j < this.districts.length; j++) {
        if (this.district == this.districts[j]) {
          this.districtId = this.districtsId[j];
        }
      }
      if (this.district == null) {
        this.msg = "Please select district options";
        this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        this.validateselection = false;
      }

      for (var j = 0; j < this.cities.length; j++) {
        if (this.city == this.cities[j]) {
          this.cityId = this.citiesId[j];
        }
      }

      var datas = {};
      datas["firstname"] = this.firstname;
      datas["lastname"] = this.lastname;
      datas["country"] = this.country;
      datas["state"] = this.stateId;
      datas["district"] = this.districtId;
      datas["pincode"] = this.pincode;
      datas["streetAddress"] = this.streetAddress;
      datas["locality"] = this.locality;
      datas["city"] = this.cityId;
      // this.dialog = false;
      axios({
        method: "POST",
        url: "/billingaddress/add/",
        data: datas,
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          if (response.data.status == true) {
            this.billid = response.data.id;
            this.msg = "successfully registered";
            this.$dlg.alert(
              this.msg,
              () => {
                this.$router.push("/AppLogin/");
              },
              { messageType: "success" }
            );
          } else {
            this.msg = response.data.msg;
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          }
        })
        .catch(e => {
          this.msg = "Not Success";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        });
    },

    reginit() {
      if (this.state == null) {
        this.msg = "Please select state options";
        this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        this.validateselection = false;
      }

      for (var j = 0; j < this.districts.length; j++) {
        if (this.district == this.districts[j]) {
          this.districtId = this.districtsId[j];
        }
      }
      if (this.district == null) {
        this.msg = "Please select district options";
        this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        this.validateselection = false;
      }

      for (var j = 0; j < this.cities.length; j++) {
        if (this.city == this.cities[j]) {
          this.cityId = this.citiesId[j];
        }
      }

      var datas = {};
      datas["firstname"] = this.firstname;
      datas["lastname"] = this.lastname;
      datas["country"] = this.country;
      datas["state"] = this.stateId;
      datas["district"] = this.districtId;
      datas["pincode"] = this.pincode;
      datas["streetAddress"] = this.streetAddress;
      datas["locality"] = this.locality;
      datas["city"] = this.cityId;
      // this.dialog = false;
      axios({
        method: "POST",
        url: "/deliveryaddress/add/",
        data: datas,
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          if (response.data.status == true) {
            this.delid = response.data.id;

            this.msg = "successfully registered";
            this.$dlg.alert(
              this.msg,
              () => {
                this.$router.push("/AppLogin/");
              },
              { messageType: "success" }
            );
          } else {
            this.msg = response.data.msg;
            this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
          }
        })
        .catch(e => {
          this.msg = "Not Success";
          this.$dlg.alert(this.msg, () => {}, { messageType: "error" });
        });
    }
  }
};
</script>
<style scoped>
.hh {
  background-color: #ff4e00;
  background-image: linear-gradient(315deg, #ff4e00 0%, #ec9f05 74%);
}
</style>